import React, {useRef} from 'react';
import trialSettings from '../TrialUI/trialSettings';
import reducer from './reducer';
import queItem from './queItem';

const TrialCache = React.createContext();



const TrialCacheProvider = props => {

  // -- state
  // data - cache of trial data. -- [data_id]: [data_result]
  // status - status of data. -- [data_id]: [status_value]
    /* status
      -4 = flag for cleanup
      -1 = prioritize fetch
      0 = not fetched
      1 = fetching
      2 = complete
      3 = expired ??
      4 = error
      10 = user controlled fetch
    */
  // index = fetching index order
  const [state, dispatch] = React.useReducer(reducer, {
    cache: {},
    items: [],
    queLimit: 1,
  });
  const que = useRef({});
  let updateStore = [];

  // -- general update of cache item
  const updateCacheItem = (update) => dispatch({
    type: 'item_update',
    id: update.id,
    payload: update.payload,
  })

  // -- test list of ids against cache
  const validateIDs = ids => {
    let areValid = true;
    ids.forEach(id => {
      if (!state.items.includes(id)) areValid = false;
    })
    return areValid;
  }

  // -- add to cache
  const addToCache = (id, path, options={}) => {
    const isArray = Array.isArray(id);
    if (isArray)
      dispatch({
        type: 'add_multiple',
        items: id,
      })
    else if (!isArray && !state.cache[id])
      dispatch({
        type: 'add',
        id: id,
        path,
        options,
      })
    else console.error('invalid formatting for cache object')
  }

  // -- user controlled data fetch save to cache
  const saveToCache = (id, data) => dispatch({type: 'save_to_cache', id: id, data: data})

  // -- remove from cache
  const removeFromCache = (id) => {
    if (state.cache[id]) dispatch({type: 'remove', id: id})
  }

  // -- flag cache for update
  const refreshCache = id => {
    if (state.cache[id]) {
      dispatch({type: 'update_status', id: id, value: 0})
      setTimeout(() => {
        dispatch({type: 'update_status', id: id, value: -1})
      }, 150)
    }
  }

  // -- initialize
  const initialized = useRef(false);
  if (props.initial && !initialized.current) {
    initialized.current = true;
    addToCache(props.initial);
  }


  const queIDs = Object.keys(que.current);

  const clearQueItem = queID => {
      // console.log('clear que item - ' + queID)
      const status = state.cache[queID].status;
      if (status === 1) que.current[queID].stop('Fetch Cancelled to clear que');
      que.current[queID] = null;
      let newQue = {...que.current};
      delete newQue[queID];
      que.current = newQue;
  }

  // -- set priority ques
  const checkPriorities = () => state.items
    .filter(id => state.cache[id].status === -1
    || (que.current[id] && que.current[id].isPriority));;

  const priorityQueIDs = checkPriorities();
  if (state.items.length) {
    let priorityQues = priorityQueIDs
    .filter(id => state.cache[id].status === -1 && !queIDs.includes(id))
    priorityQues.forEach(cacheID => {

      let canRemove = [];
      const ques = Object.keys(que.current);
      const atMax = ques.length >= state.queLimit;
      if (atMax) {
        ques.forEach(queID => {
          if (!que.current[queID].isPriority)
          canRemove.push(queID);
        })
      }
      if (atMax && canRemove.length) canRemove.forEach(id => clearQueItem(id));
      if (!atMax || (atMax && canRemove.length)) {
        const parsedID = cacheID.includes('_po_')
        ? cacheID.split('_po_')[0]
        : cacheID;
        const cacheItem = state.cache[cacheID];
        const tabSettings = trialSettings.tabs[parsedID];
        const itemStatus = cacheItem.status;
        que.current[cacheID] = new queItem({
          cacheItem: cacheItem,
          status: itemStatus,
          id: cacheID,
          // updateItem: (update) => updateStore.push({id: cacheID, payload: update}),
          // updateStatus: (update) => updateStore.push({id: cacheID, payload: {status: update}}),
          updateItem: (update) => updateCacheItem({id: cacheID, payload: update}),
          updateStatus: (update) => updateCacheItem({id: cacheID, payload: {status: update}}),
          tabSettings: tabSettings,
        })
      }
    })
  }

  // -- clear completed ques
  queIDs.forEach(queID => {
    const status = state.cache[queID].status;
    if (status === 2 || status === 4) clearQueItem(queID);
  })

  // -- fetch updates if needed
  if (state.items.length && state.cache) {
    state.items.forEach(cacheID => {

      const parsedID = cacheID.includes('_po_')
      ? cacheID.split('_po_')[0]
      : cacheID;
      const cacheItem = state.cache[cacheID];
      const tabSettings = trialSettings.tabs[parsedID];
      const itemStatus = cacheItem.status;

      // add items to que
      if (itemStatus === 0) {
        if (priorityQueIDs.length === 0
        && Object.keys(que.current).length < state.queLimit
        && !Object.keys(que.current).includes(cacheID)) {
          que.current[cacheID] = new queItem({
            cacheItem: cacheItem,
            status: itemStatus,
            id: cacheID,
            // updateItem: (update) => updateStore.push({id: cacheID, payload: update}),
            // updateStatus: (update) => updateStore.push({id: cacheID, payload: {status: update}}),
            updateItem: (update) => updateCacheItem({id: cacheID, payload: update}),
            updateStatus: (update) => updateCacheItem({id: cacheID, payload: {status: update}}),
            tabSettings: tabSettings,
          });
        }
      }

    })
  }


  // -- check expiration times ??



  return(
    <TrialCache.Provider
      value={{
        cache: state.cache,
        items: state.items,
        prioritizeCache: (id) => {
          if (state.cache[id] && state.cache[id].status === 0
            // || (state.cache[id].status === 1 && !que.current[id].isPriority)
          ) {
            if (que.current[id] && !que.current[id].isPriority) clearQueItem(id);
            updateCacheItem({id: id, payload: {status: -1}})
          } else updateCacheItem({id: id, payload: {status: -1}})
          // console.log(que, state, id, "Priority")
        },
        addToCache,
        removeFromCache,
        refreshCache,
        saveToCache,
      }}
    >
      {props.children}
    </TrialCache.Provider>
  )
}

const TrialCacheConsumer = TrialCache.Consumer;
export {TrialCache, TrialCacheProvider, TrialCacheConsumer};
